import api from './api';
import { Document } from '../types/document';

interface GetDocumentsResponse {
  data: Document[];
  total: number;
}

export const getDocumentsForUser = async (
  userId: string,
  page: number,
  pageSize: number,
  sortBy: string,
  order: 'asc' | 'desc'
): Promise<GetDocumentsResponse> => {
  const response = await api.get('/documents', {
    params: { userId, page, pageSize, sortBy, order },
  });
  return response.data;
};

type DocumentCreationData = Omit<Document, 'id' | 'createdAt' | 'updatedAt' | 'documentType' | 'user' | 'status' | 'rejectionReason' | 'isVerified' | 'isSystem'>;
type DocumentUpdateData = Omit<DocumentCreationData, 'userId'>;


export const createDocument = async (documentData: DocumentCreationData): Promise<Document> => {
  const response = await api.post('/documents', documentData);
  return response.data;
};

export const updateDocument = async (documentId: string, documentData: DocumentUpdateData): Promise<Document> => {
  const response = await api.put(`/documents/${documentId}`, documentData);
  return response.data;
};

export const deleteDocument = async (documentId: string): Promise<void> => {
  await api.delete(`/documents/${documentId}`);
};

/** Indirizzo per aprire un documento: passa dal server, che controlla i permessi. */
export const getDocumentViewUrl = (documentId: string): string =>
  `${process.env.REACT_APP_API_BASE_URL || ''}/documents/${documentId}/view`;

export const uploadDocumentFile = async (documentId: string, file: File): Promise<Document> => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/documents/${documentId}/upload`, formData);
  return response.data;
};

export const getPendingDocuments = async (): Promise<Document[]> => {
  const response = await api.get('/documents/pending');
  return response.data;
};

export const getPendingDocumentsCount = async (): Promise<number> => {
  const response = await api.get('/documents/pending-count');
  return response.data.count;
};

export const updateDocumentStatus = async (documentId: string, status: 'APPROVED' | 'REJECTED', rejectionReason?: string): Promise<Document> => {
  const response = await api.patch(`/documents/${documentId}/status`, { status, rejectionReason });
  return response.data;
};

export const checkCompliance = async (): Promise<any[]> => {
    const response = await api.get('/documents/compliance');
    return response.data;
};
